import React from 'react';
import { Checkbox, TableCell, TableRow } from '@mui/material';
import { AttachmentItem } from '@klab-berlin/api-sdk/lib/types/responses/Common';

import { boxShadows, palette, spaces } from '../../assets/styles/themes/tokens';
import CheckBoxIcon from '../../assets/check-box.svg';
import CheckBoxCheckedIcon from '../../assets/check-box-checked.svg';
import AttachmentTableItem from './AttachmentTableItem';
import { AttachmentType } from './AttachmentsTableHeader';
import { ALLOWED_NESTED_LEVEL } from './AttachmentsTable';

interface AttachmentTableRowProps {
    isItemSelected: boolean;
    row: AttachmentItem;
    onClickItem: () => void;
    onClickCheckBox: () => void;
    onClickItemDownload: () => Promise<void>;
    nestedLevel: number;
}

const AttachmentTableRow = ({
  isItemSelected,
  row,
  onClickItem,
  onClickCheckBox,
  onClickItemDownload,
  nestedLevel
}: AttachmentTableRowProps) => {

  const cursorSetting = nestedLevel < ALLOWED_NESTED_LEVEL &&
    row.type.toLowerCase() === AttachmentType.FOLDER ? 'pointer' : 'unset';

  return (
    <TableRow
      data-testid='attachment-table-row'
      aria-checked={isItemSelected}
      key={row.contentPath}
      selected={isItemSelected}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: cursorSetting,
        marginBottom: spaces.xs,
        '&:hover': {
          color: palette.primary.main,

          '.download-attachment-button': {
            visibility: 'visible',
            opacity: 1,
          },
          '.attachment-item-folder': {
            boxShadow: boxShadows.elevation2,

            '.attachment-title': {
              color: palette.primary.main,
            }
          },
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: 'unset',
        },
        '&.Mui-selected': {
          '.attachment-item-file': {
            borderColor: palette.primary.main,
          },
          '.attachment-item-folder': {
            borderColor: palette.primary.main,
            boxShadow: boxShadows.elevation2,

            '.attachment-title': {
              color: palette.primary.main,
            }
          },
        },
      }}
    >
      <TableCell sx={{ borderBottom: 'none' }} padding='checkbox'>
        <Checkbox
          inputProps={{ 'data-testid': `attachment-table-row-checkbox-${row.fileName}` } as React
            .InputHTMLAttributes<HTMLInputElement>}
          checked={isItemSelected}
          icon={<CheckBoxIcon />}
          checkedIcon={<CheckBoxCheckedIcon />}
          onClick={onClickCheckBox}
          sx={{
            color: palette.action.active,
          }}
        />
      </TableCell>
      <TableCell
        component='th'
        scope='row'
        padding='none'
        sx={{
          width: '100%',
          borderBottom: 'none',
          marginLeft: spaces.sm
        }}
        onClick={onClickItem}
      >
        <AttachmentTableItem item={row} onClickItemDownload={onClickItemDownload} />
      </TableCell>
    </TableRow>
  );
};

export default AttachmentTableRow;
